import { render, staticRenderFns } from "./TableCategoryOfCustomer.vue?vue&type=template&id=76a3b938"
import script from "./TableCategoryOfCustomer.vue?vue&type=script&lang=js"
export * from "./TableCategoryOfCustomer.vue?vue&type=script&lang=js"
import style0 from "./TableCategoryOfCustomer.vue?vue&type=style&index=0&id=76a3b938&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports